
namespace GeniuzPOS.Lookups {

    @Serenity.Decorators.registerClass()
    export class LookupBgColorDialog extends Serenity.EntityDialog<LookupBgColorRow, any> {
        protected getFormKey() { return LookupBgColorForm.formKey; }
        protected getIdProperty() { return LookupBgColorRow.idProperty; }
        protected getLocalTextPrefix() { return LookupBgColorRow.localTextPrefix; }
        protected getNameProperty() { return LookupBgColorRow.nameProperty; }
        protected getService() { return LookupBgColorService.baseUrl; }
        protected getDeletePermission() { return LookupBgColorRow.deletePermission; }
        protected getInsertPermission() { return LookupBgColorRow.insertPermission; }
        protected getUpdatePermission() { return LookupBgColorRow.updatePermission; }

        protected form = new LookupBgColorForm(this.idPrefix);

    }
}